import { render, staticRenderFns } from "./ForgotPassword.vue?vue&type=template&id=59ca59fe&scoped=true"
import script from "./ForgotPassword.vue?vue&type=script&lang=ts"
export * from "./ForgotPassword.vue?vue&type=script&lang=ts"
import style0 from "./ForgotPassword.vue?vue&type=style&index=0&id=59ca59fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ca59fe",
  null
  
)

export default component.exports